import { render, staticRenderFns } from "./OrderPropertyListGroup.vue?vue&type=template&id=65a40158&"
import script from "./OrderPropertyListGroup.vue?vue&type=script&lang=js&"
export * from "./OrderPropertyListGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65a40158')) {
      api.createRecord('65a40158', component.options)
    } else {
      api.reload('65a40158', component.options)
    }
    module.hot.accept("./OrderPropertyListGroup.vue?vue&type=template&id=65a40158&", function () {
      api.rerender('65a40158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/OrderPropertyListGroup.vue"
export default component.exports